
import React, { useState, useEffect } from 'react';
import { ChevronRight, Calendar, MapPin, Plus, X, Search, ExternalLink, Edit, CheckCircle, Upload, Camera, Download,RotateCcw ,Eye } from 'lucide-react';
import { apiService } from "../components/api";

function NorthstarDashboard() {
  const [camps, setCamps] = useState([]);
  const [selectedCamp, setSelectedCamp] = useState(null);
  const [patients, setPatients] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showAddPatient, setShowAddPatient] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingPatient, setEditingPatient] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    loadCamps();
  }, []);

  const loadCamps = async () => {
    try {
      setLoading(true);
      const data = await apiService.northstar.getAllCamps();
      setCamps(data);
    } catch (error) {
      console.error('Error loading camps:', error);
      alert('Failed to load camps: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // const handleCampClick = async (camp) => {
  //   try {
  //     setSelectedCamp(camp);
  //     setPatients([]);
  //     setTotalRecords(0);
      
  //     const response = await apiService.northstar.getPackagePatients(camp.id, null);
  //     console.log('login email', localStorage.getItem("email"));
      
  //     if (response && response.results) {
  //       setPatients(response.results);
  //       setTotalRecords(response.total_records || response.results.length);
  //     } else if (Array.isArray(response)) {
  //       setPatients(response);
  //       setTotalRecords(response.length);
  //     } else {
  //       setPatients([]);
  //       setTotalRecords(0);
  //     }
  //   } catch (error) {
  //     console.error('Error loading patients:', error);
  //     alert('Failed to load patients: ' + error.message);
  //     setPatients([]);
  //     setTotalRecords(0);
  //   }
  // };



  const handleCampClick = async (camp) => {
  try {
    setSelectedCamp(camp);
    setPackages([]);
    setLoading(true);
    
    // Fetch camp details with packages
    const response = await fetch(`https://cbackend.xraidigital.com/api/campmanager/camps/${camp.id}/details/`);
    const data = await response.json();
    
    if (data && data.packages) {
      setPackages(data.packages);
    } else {
      setPackages([]);
      alert('No packages found for this camp');
    }
  } catch (error) {
    console.error('Error loading packages:', error);
    alert('Failed to load packages: ' + error.message);
    setPackages([]);
  } finally {
    setLoading(false);
  }
};




const handlePackageClick = async (packageData) => {
  try {
    setSelectedPackage(packageData);
    setPatients([]);
    setTotalRecords(0);
    
    const response = await apiService.northstar.getPackagePatients(selectedCamp.id, packageData.id);
    
    if (response && response.results) {
      setPatients(response.results);
      setTotalRecords(response.total_records || response.results.length);
    } else if (Array.isArray(response)) {
      setPatients(response);
      setTotalRecords(response.length);
    } else {
      setPatients([]);
      setTotalRecords(0);
    }
  } catch (error) {
    console.error('Error loading patients:', error);
    alert('Failed to load patients: ' + error.message);
    setPatients([]);
    setTotalRecords(0);
  }
};






  const handleBack = () => {
  if (selectedPackage) {
    // Go back to packages view
    setSelectedPackage(null);
    setPatients([]);
    setTotalRecords(0);
  } else if (selectedCamp) {
    // Go back to camps view
    setSelectedCamp(null);
    setPackages([]);
  }
};

  const filteredPatients = patients.filter(patient => 
    searchTerm === '' || 
    patient.nirman_number?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    patient.patient_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    patient.contact_number?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getRowColor = (patient) => {
    const hasSaman = patient.saman_id_number && patient.saman_id_number.trim() !== '';
    const hasSuflam = patient.suflam_id_number && patient.suflam_id_number.trim() !== '';
    
    if (hasSaman && hasSuflam) {
      return 'bg-green-50';
    } else if (hasSaman || hasSuflam) {
      return 'bg-yellow-50';
    } else {
      return 'bg-red-50';
    }
  };


const handleDownload = async (url, filename) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = blobUrl;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Download failed', error);
    alert('Failed to download file');
  }
};


const downloadPatientFolderFrontend = async (patient) => {
  try {
    if (!window.showDirectoryPicker) {
      alert("Your browser does not support folder download. Use Chrome or Edge.");
      return;
    }

    // Ask user to pick a base directory
    const baseDirHandle = await window.showDirectoryPicker();

    const folderName =
      patient.nirman_number || patient.unique_patient_id || "patient";

    // Create Nirman Number folder
    const patientDir = await baseDirHandle.getDirectoryHandle(folderName, {
      create: true,
    });

    const files = [
      { url: patient.nirman_card, name: "Nirman_Card.jpg" },
      { url: patient.aadhar_front, name: "Aadhaar_Front.jpg" },
      { url: patient.aadhar_back, name: "Aadhaar_Back.jpg" },
      { url: patient.photo, name: "Patient_Photo.jpg" },
    ];

    for (const file of files) {
      if (!file.url) continue;

      const response = await fetch(file.url);
      const blob = await response.blob();

      const fileHandle = await patientDir.getFileHandle(file.name, {
        create: true,
      });

      const writable = await fileHandle.createWritable();
      await writable.write(blob);
      await writable.close();
    }

    alert("Folder downloaded successfully");
  } catch (error) {
    console.error("Folder download failed", error);
    alert("Download cancelled or failed");
  }
};




  const reloadPatients = async () => {
    if (selectedCamp) {
      try {
        const response = await apiService.northstar.getPackagePatients(selectedCamp.id, null);
        if (response && response.results) {
          setPatients(response.results);
          setTotalRecords(response.total_records || response.results.length);
        }
      } catch (error) {
        console.error('Error reloading patients:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-xl text-indigo-600">Loading camps...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-2">
            {selectedCamp && (
              <button
                onClick={handleBack}
                className="text-indigo-600 hover:text-indigo-800 font-medium"
              >
                ← Back
              </button>
            )}
          </div>
          
         <h1 className="text-4xl font-bold text-gray-800 mb-2">
  {selectedPackage ? `${selectedCamp.location} - ${selectedPackage.name} - Patients` :
   selectedCamp ? `${selectedCamp.location} - Packages` :
   'Northstar Dashboard'}
</h1>
<p className="text-gray-600">
  {selectedPackage ? `${totalRecords} patient${totalRecords !== 1 ? 's' : ''} registered` :
   selectedCamp ? `${packages.length} package${packages.length !== 1 ? 's' : ''} available` :
   `${camps.length} Active Northstar Camps`}
</p>
        </div>

        {/* Camps List */}
        {!selectedCamp && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {camps.map((camp) => (
              <div
                key={camp.id}
                onClick={() => handleCampClick(camp)}
                className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow cursor-pointer p-6 border-l-4 border-indigo-500"
              >
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl font-semibold text-gray-800">{camp.location}</h3>
                  <ChevronRight className="text-indigo-500" />
                </div>
                <div className="space-y-2 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <MapPin size={16} className="text-indigo-500" />
                    <span>{camp.district}, {camp.state}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar size={16} className="text-indigo-500" />
                    <span>{camp.start_date} to {camp.end_date}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-medium">Client: {camp.client}</span>
                  </div>
                </div>
                <div className="mt-4 flex gap-2">
                  {camp.ready_to_go && (
                    <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">Ready</span>
                  )}
                  {camp.is_completed && (
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">Completed</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}


        {/* Packages List */}
{selectedCamp && !selectedPackage && (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {packages.map((pkg) => (
      <div
        key={pkg.id}
        onClick={() => handlePackageClick(pkg)}
        className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow cursor-pointer p-6 border-l-4 border-green-500"
      >
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-xl font-semibold text-gray-800">{pkg.name}</h3>
          <ChevronRight className="text-green-500" />
        </div>
        <div className="space-y-2 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <Calendar size={16} className="text-green-500" />
            <span>{pkg.start_date} to {pkg.end_date}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs font-medium">Services: {pkg.service_ids.length}</span>
          </div>
        </div>
      </div>
    ))}
  </div>
)}

        {/* Patients Table */}
        {selectedPackage && (
          <div className="bg-white rounded-xl shadow-md p-6">
            <div className="flex justify-between items-center mb-6">
              <div className="flex items-center gap-4 flex-1">
                <div className="relative flex-1 max-w-md">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="text"
                    placeholder="Search by Nirman number, name, contact..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>
              <button
                onClick={() => setShowAddPatient(true)}
                className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition"
              >
                <Plus size={20} />
                Add Patient
              </button>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nirman Number</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aadhaar Number</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nirman Card</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aadhaar Front</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aadhaar Back</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Download All</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Saman ID</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Suflam ID</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredPatients.length > 0 ? (
                    filteredPatients.map((patient) => (
                      <tr key={patient.id} className={`hover:bg-gray-100 ${getRowColor(patient)}`}>
                        <td className="px-4 py-4 text-sm font-medium text-gray-800">
                          {patient.nirman_number || '-'}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-800">
                          {patient.patient_name || '-'}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {patient.contact_number || '-'}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {patient.aadhar_number || '-'}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {patient.nirman_card ? (
                          <div className="flex items-center gap-3">
                            {/* View */}
                            <a
                              href={patient.nirman_card}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center gap-1 text-indigo-600 hover:text-indigo-800"
                            >
                              View <ExternalLink size={14} />
                            </a>
                        
                            {/* Download */}
                            <button
                               onClick={() =>
                                 handleDownload(
                                   patient.nirman_card,
                                   `${patient.nirman_number}_nirman_card.jpg`
                                 )
                               }
                               className="flex items-center gap-1 text-green-600 hover:text-green-800"
                             >
                               <Download size={14} />
                             </button>
                             
                          </div>
                            
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {patient.aadhar_front ? (
                            <div className="flex items-center gap-3">
                            <a
                              href={patient.aadhar_front}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center gap-1 text-indigo-600 hover:text-indigo-800"
                            >
                              View <ExternalLink size={14} />
                            </a>
                            <button
                               onClick={() =>
                                 handleDownload(
                                   patient.aadhar_front,
                                   `${patient.nirman_number}_aadhar_front.jpg`
                                 )
                               }
                               className="flex items-center gap-1 text-green-600 hover:text-green-800"
                             >
                               <Download size={14} />
                             </button>

                            </div>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {patient.aadhar_back ? (
                            <div className="flex items-center gap-3">
                            <a
                              href={patient.aadhar_back}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center gap-1 text-indigo-600 hover:text-indigo-800"
                            >
                              View <ExternalLink size={14} />
                            </a>
                              <button
                                onClick={() =>
                                  handleDownload(
                                    patient.aadhar_back,
                                    `${patient.nirman_number}_aadhar_back.jpg`
                                  )
                                }
                                className="flex items-center gap-1 text-green-600 hover:text-green-800"
                              >
                                <Download size={14} />
                              </button>
                            </div>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-4 text-sm">
                         <button
                           onClick={() => downloadPatientFolderFrontend(patient)}
                           className="flex items-center gap-2 bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
                         >
                           <Download size={16} />
                           Download
                         </button>
                       </td>
                       
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {patient.saman_id_number || '-'}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {patient.suflam_id_number || '-'}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                          <button
                            onClick={() => setEditingPatient(patient)}
                            className="flex items-center text-blue-600 hover:text-blue-700"
                          >
                            <Edit className="h-4 w-4 mr-1" />
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="px-6 py-8 text-center text-gray-500">
                        {searchTerm ? 'No patients found matching your search' : 'No patients added yet'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Add Patient Modal */}
        {showAddPatient && (
          <AddPatientModal 
            campId={selectedCamp.id}
            packageId={selectedPackage.id}
            onClose={() => setShowAddPatient(false)}
            onSuccess={reloadPatients}
          />
        )}

        {/* Edit Patient Modal */}
        {editingPatient && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
    <div className="max-w-3xl w-full my-8"> {/* Changed from max-w-4xl to max-w-3xl */}
      <PatientEditForm
        patient={editingPatient}
        onClose={() => setEditingPatient(null)}
        onSave={() => {
          setEditingPatient(null);
          reloadPatients();
        }}
      />
    </div>
  </div>
)}
      </div>
    </div>
  );
}
// Updated CameraFileUpload Component
function CameraFileUpload({ label, fieldName, file, preview, cameraStream, onFileChange, onCameraCapture, onCapture, onRemove, disabled }) {
  const [showFullImage, setShowFullImage] = useState(false);

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-3">
        {cameraStream ? (
          <div className="space-y-2">
            <video
              id={`video-${fieldName}`}
              autoPlay
              playsInline
              ref={(video) => {
                if (video && cameraStream) {
                  video.srcObject = cameraStream;
                }
              }}
              className="w-full rounded"
            />
            <button
              onClick={() => onCapture(fieldName)}
              className="w-full px-3 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700"
              disabled={disabled}
            >
              Capture Photo
            </button>
          </div>
        ) : preview ? (
          <div className="space-y-2">
            <div className="relative cursor-pointer" onClick={() => setShowFullImage(true)}>
              <img 
                src={preview} 
                alt="Preview" 
                className="w-full h-32 object-cover rounded" 
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-10 transition-all rounded flex items-center justify-center">
                <Eye className="text-white opacity-0 hover:opacity-100 transition-opacity" size={24} />
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => onRemove(fieldName)}
                className="flex-1 flex items-center justify-center gap-1 px-3 py-1 bg-red-600 text-white text-xs rounded hover:bg-red-700"
                disabled={disabled}
              >
                <X size={14} />
                Remove
              </button>
              <button
                onClick={() => onCameraCapture(fieldName)}
                className="flex-1 flex items-center justify-center gap-1 px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700"
                disabled={disabled}
              >
                <RotateCcw size={14} />
                Retake
              </button>
            </div>
          </div>
        ) : (
          <>
            <input
              type="file"
              id={`file-${fieldName}`}
              onChange={(e) => onFileChange(e, fieldName)}
              className="hidden"
              accept="image/*"
              disabled={disabled}
            />
            <div className="flex flex-col items-center gap-2">
              <Upload className="h-8 w-8 text-gray-400" />
              <label
                htmlFor={`file-${fieldName}`}
                className="cursor-pointer text-xs text-indigo-600 hover:text-indigo-700"
              >
                Choose File
              </label>
              <button
                onClick={() => onCameraCapture(fieldName)}
                className="flex items-center gap-1 text-xs text-green-600 hover:text-green-700"
                disabled={disabled}
              >
                <Camera size={14} />
                Use Camera
              </button>
            </div>
          </>
        )}
      </div>

      {/* Full Image Modal */}
      {showFullImage && preview && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-[100] flex items-center justify-center p-4"
          onClick={() => setShowFullImage(false)}
        >
          <div className="relative max-w-4xl max-h-[90vh] w-full">
            <button
              onClick={() => setShowFullImage(false)}
              className="absolute top-4 right-4 bg-white rounded-full p-2 hover:bg-gray-100 transition z-10"
            >
              <X size={24} className="text-gray-800" />
            </button>
            <img 
              src={preview} 
              alt={`${label} full view`}
              className="w-full h-full object-contain rounded"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
}

// Updated AddPatientModal Component
function AddPatientModal({ campId, packageId, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    nirman_number: '',
    aadhar_number: '',
  });
  
  const [files, setFiles] = useState({
    nirman_card: null,
    aadhar_front: null,
    aadhar_back: null,
    photo: null,
  });
  
  const [previews, setPreviews] = useState({});
  const [uploading, setUploading] = useState(false);
  const [useCamera, setUseCamera] = useState({});

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        alert('File size must be less than 10MB');
        e.target.value = '';
        return;
      }

      if (!file.type.startsWith('image/')) {
        alert(`${fieldName} must be an image file`);
        e.target.value = '';
        return;
      }

      setFiles({
        ...files,
        [fieldName]: file
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews({
          ...previews,
          [fieldName]: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCameraCapture = async (fieldName) => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { facingMode: 'environment' } 
      });
      setUseCamera({ ...useCamera, [fieldName]: stream });
    } catch (error) {
      console.error('Error accessing camera:', error);
      alert('Could not access camera. Please use file upload instead.');
    }
  };

  const capturePhoto = (fieldName) => {
    const video = document.getElementById(`video-${fieldName}`);
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);
    
    canvas.toBlob((blob) => {
      const file = new File([blob], `${fieldName}.jpg`, { type: 'image/jpeg' });
      setFiles({
        ...files,
        [fieldName]: file
      });
      setPreviews({
        ...previews,
        [fieldName]: canvas.toDataURL('image/jpeg')
      });
      
      // Stop camera stream after capture
      const stream = useCamera[fieldName];
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
        setUseCamera({ ...useCamera, [fieldName]: null });
      }
    }, 'image/jpeg');
  };

  const handleRemoveImage = (fieldName) => {
    // Remove the file and preview
    setFiles({
      ...files,
      [fieldName]: null
    });
    setPreviews({
      ...previews,
      [fieldName]: null
    });
    
    // Stop camera if it's running
    const stream = useCamera[fieldName];
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setUseCamera({ ...useCamera, [fieldName]: null });
    }
  };

  const handleSubmit = async () => {
    const nirman = formData.nirman_number?.trim();
    const aadhar = formData.aadhar_number?.trim();

    // Required check
    if (!nirman) {
      alert('Nirman Number is required');
      return;
    }

    // Length validations
    if (nirman.length < 10) {
      alert('Nirman Number must be exactly 10 digits');
      return;
    }

    if (aadhar && aadhar.length < 12) {
      alert('Aadhar Number must be exactly 12 digits');
      return;
    }

    setUploading(true);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append('nirman_number', nirman);
      formDataToSend.append('camp', campId);
      formDataToSend.append('photo', formData.photo || '');
      formDataToSend.append('package', packageId);
      formDataToSend.append('service', 'X-ray, ECG, PFT,NorthStar_Assesment_Form, blood');
      formDataToSend.append(
        'registered_by',
        localStorage.getItem("coordinatorId")
      );

      if (aadhar) {
        formDataToSend.append('aadhar_number', aadhar);
      }

      Object.keys(files).forEach(key => {
        if (files[key]) {
          formDataToSend.append(key, files[key]);
        }
      });

      await apiService.northstar.registerPatient(formDataToSend);

      alert('Patient registered successfully');
      onSuccess();
      onClose();

    } catch (error) {
      console.error('Registration error:', error);
      alert('Failed to register patient: ' + error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
      <div className="min-h-screen flex items-center justify-center p-4 py-8">
        <div className="bg-white rounded-xl p-6 w-full max-w-2xl my-8">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold text-gray-800">Add New Patient</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              disabled={uploading}
            >
              <X size={24} />
            </button>
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Nirman Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="nirman_number"
                  value={formData.nirman_number}
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter Nirman"
                  className="w-full px-2 sm:px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm"
                  disabled={uploading}
                  maxLength={10}
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Aadhaar Number
                </label>
                <input
                  type="number"
                  name="aadhar_number"
                  value={formData.aadhar_number}
                  onChange={(e) => {
                    if (e.target.value.length <= 12) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter Aadhaar"
                  className="w-full px-2 sm:px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm"
                  disabled={uploading}
                  maxLength={12}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <CameraFileUpload
                label="Nirman Card"
                fieldName="nirman_card"
                file={files.nirman_card}
                preview={previews.nirman_card}
                cameraStream={useCamera.nirman_card}
                onFileChange={handleFileChange}
                onCameraCapture={handleCameraCapture}
                onCapture={capturePhoto}
                onRemove={handleRemoveImage}
                disabled={uploading}
              />
              <CameraFileUpload
                label="Aadhaar Front"
                fieldName="aadhar_front"
                file={files.aadhar_front}
                preview={previews.aadhar_front}
                cameraStream={useCamera.aadhar_front}
                onFileChange={handleFileChange}
                onCameraCapture={handleCameraCapture}
                onCapture={capturePhoto}
                onRemove={handleRemoveImage}
                disabled={uploading}
              />
              <CameraFileUpload
                label="Aadhaar Back"
                fieldName="aadhar_back"
                file={files.aadhar_back}
                preview={previews.aadhar_back}
                cameraStream={useCamera.aadhar_back}
                onFileChange={handleFileChange}
                onCameraCapture={handleCameraCapture}
                onCapture={capturePhoto}
                onRemove={handleRemoveImage}
                disabled={uploading}
              />
              <CameraFileUpload
                label="Patient Photo"
                fieldName="photo"
                file={files.photo}
                preview={previews.photo}
                cameraStream={useCamera.photo}
                onFileChange={handleFileChange}
                onCameraCapture={handleCameraCapture}
                onCapture={capturePhoto}
                onRemove={handleRemoveImage}
                disabled={uploading}
              />
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
                disabled={uploading}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition disabled:bg-indigo-400 disabled:cursor-not-allowed"
                disabled={uploading}
              >
                {uploading ? 'Registering...' : 'Register Patient'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}




function PatientEditForm({ patient, onClose, onSave }) {
  const [formData, setFormData] = useState({
    patient_name: '',  
    age: '',
    gender: '',
    dob: '',
    contact_number: '', 
    nirman_number: patient.nirman_number || '',
    suflam_id_number: '', 
    saman_id_number: '',
    aadhar_number: ''
  });

  const [files, setFiles] = useState({
    nirman_card: null,
    aadhar_front: null,
    aadhar_back: null,
    photo: null,
    swikrati_photo: null,
    saman_file: null  // Added Saman file
  });

  const [previews, setPreviews] = useState({});
  const [uploading, setUploading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    const fetchPatientData = async () => {
      if (patient.nirman_number) {
        setLoadingData(true);
        try {
          const response = await apiService.northstar.getAllpaientsData(patient.nirman_number);
          const patientData = response.data || response;
          
          setFormData({
            patient_name: patientData.patient_name || '',
            age: patientData.age || '',
            gender: patientData.gender || '',
            nirman_number: patientData.nirman_number || patient.nirman_number,
            suflam_id_number: patientData.suflam_id_number || '',
            saman_id_number: patientData.saman_id_number || '',
            contact_number: patientData.contact_number || '',
            aadhar_number: patientData.aadhar_number || ''
          });

          // Store existing file URLs in previews
          const newPreviews = {};
          if (patientData.photo) newPreviews.photo = patientData.photo;
          if (patientData.swikrati_photo) newPreviews.swikrati_photo = patientData.swikrati_photo;
          if (patientData.nirman_card) newPreviews.nirman_card = patientData.nirman_card;
          if (patientData.aadhar_front) newPreviews.aadhar_front = patientData.aadhar_front;
          if (patientData.aadhar_back) newPreviews.aadhar_back = patientData.aadhar_back;
          if (patientData.saman_file) newPreviews.saman_file = patientData.saman_file; // Added
          
          setPreviews(newPreviews);

        } catch (error) {
          console.error('Error fetching patient data:', error);
        } finally {
          setLoadingData(false);
        }
      } else {
        setLoadingData(false);
      }
    };

    fetchPatientData();
  }, [patient]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        alert('File size must be less than 10MB');
        e.target.value = '';
        return;
      }

      // Check if file is an image for image fields
      const imageFields = ['photo', 'nirman_card', 'swikrati_photo', 'aadhar_front', 'aadhar_back'];
      if (imageFields.includes(fieldName) && !file.type.startsWith('image/')) {
        alert(`${fieldName} must be an image file`);
        e.target.value = '';
        return;
      }

      // Accept both images and PDFs for saman_file
      if (fieldName === 'saman_file') {
        if (!file.type.startsWith('image/') && file.type !== 'application/pdf') {
          alert('Saman file must be an image or PDF');
          e.target.value = '';
          return;
        }
      }

      setFiles({
        ...files,
        [fieldName]: file
      });

      // Create preview for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviews({
            ...previews,
            [fieldName]: reader.result
          });
        };
        reader.readAsDataURL(file);
      } else if (file.type === 'application/pdf') {
        // For PDF files, show a PDF icon
        setPreviews({
          ...previews,
          [fieldName]: 'pdf'
        });
      }
    }
  };

  const clearFile = (fieldName) => {
    setFiles({
      ...files,
      [fieldName]: null
    });
    setPreviews({
      ...previews,
      [fieldName]: null
    });
    // Reset file input
    const fileInput = document.getElementById(`file-${fieldName}`);
    if (fileInput) fileInput.value = '';
  };

  const handleSubmit = async () => {  
    setUploading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('patient_name', formData.patient_name);
      formDataToSend.append('age', formData.age);
      formDataToSend.append('gender', formData.gender);
      formDataToSend.append('contact_number', formData.contact_number);
      formDataToSend.append('nirman_number', formData.nirman_number);
      formDataToSend.append('suflam_id_number', formData.suflam_id_number);
      formDataToSend.append('saman_id_number', formData.saman_id_number);
      formDataToSend.append('aadhar_number', formData.aadhar_number);
      formDataToSend.append('dob', formData.dob);
      formDataToSend.append('updated_by', localStorage.getItem("coordinatorId"));
      // Only append files that have been changed
      Object.keys(files).forEach(key => {
        if (files[key]) {
          formDataToSend.append(key, files[key]);
        } else if (previews[key] && typeof previews[key] === 'string' && previews[key].startsWith('http')) {
          // If there's an existing URL but no new file, send the URL
          formDataToSend.append(`${key}_url`, previews[key]);
        }
      });
      
      await apiService.northstar.updatePatient(patient.nirman_number, formDataToSend);
      alert('Patient details updated successfully');
      onSave();
      onClose();
    }
    catch (error) {
      console.error('Update error:', error);
      alert('Failed to update patient: ' + error.message);
    }
    finally {
      setUploading(false);
    }
  };

  if (loadingData) {
    return (
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="text-center text-gray-600">Loading patient data...</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-md p-6 max-w-4xl w-full"> {/* Added max-w-4xl */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Edit Patient Details</h2>
          <p className="text-gray-600 text-sm">Nirman Number: {patient.nirman_number}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
          disabled={uploading}
        >
          <X size={24} />
        </button>
      </div>

      <div className="space-y-6 max-h-[70vh] overflow-y-auto pr-2"> {/* Added scroll */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Patient Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="patient_name"
              value={formData.patient_name}
              onChange={handleInputChange}
              placeholder="Enter patient name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              disabled={uploading}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Age
            </label>
            <input
              type="number"
              name="age"
              value={formData.age}
              onChange={handleInputChange}
              placeholder="Enter age"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              disabled={uploading}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">  
              Gender
            </label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              disabled={uploading}
            >
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Contact Number
            </label>
            <input
              type="tel"
              name="contact_number"
              value={formData.contact_number}
                onChange={(e) => {
                 if (e.target.value.length <= 10) {
                   handleInputChange(e);
                 }
               }}
              placeholder="Enter contact number"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              disabled={uploading}
              maxLength={10}
            />
          </div>
        </div>  

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Suflam ID Number
            </label>
            <input
              type="number"
              name="suflam_id_number"
              value={formData.suflam_id_number}
              onChange={(e) => {
                 if (e.target.value.length <= 10) {
                   handleInputChange(e);
                 }
               }}
              placeholder="Enter Suflam ID number"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              disabled={uploading}
              maxLength={10}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Saman ID Number
            </label>  
            <input
              type="number"
              name="saman_id_number"
              value={formData.saman_id_number}
              onChange={(e) => {
                 if (e.target.value.length <= 10) {
                   handleInputChange(e);
                 }
               }}
              placeholder="Enter Saman ID number"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              disabled={uploading}
              maxLength={10}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Aadhaar Number
          </label>
          <input
            type="text"
            name="aadhar_number"
            value={formData.aadhar_number}
            onChange={handleInputChange}
            placeholder="Enter Aadhaar number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            disabled={uploading}
          />
        </div>
         <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">  
              Date of Birth
            </label>
            <input
              type="date"
              name="dob"            
              value={formData.dob}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              disabled={uploading}
            />
          </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <FileUploadWithPreview
            label="Nirman Card"
            fieldName="nirman_card"
            file={files.nirman_card}
            preview={previews.nirman_card}
            onFileChange={handleFileChange}
            onClear={() => clearFile('nirman_card')}
            disabled={uploading}
          />
          
          <FileUploadWithPreview
            label="Aadhaar Front"
            fieldName="aadhar_front"
            file={files.aadhar_front}
            preview={previews.aadhar_front}
            onFileChange={handleFileChange}
            onClear={() => clearFile('aadhar_front')}
            disabled={uploading}
          />
          
          <FileUploadWithPreview
            label="Aadhaar Back"
            fieldName="aadhar_back"
            file={files.aadhar_back}
            preview={previews.aadhar_back}
            onFileChange={handleFileChange}
            onClear={() => clearFile('aadhar_back')}
            disabled={uploading}
          />
          
          <FileUploadWithPreview
            label="Photo"
            fieldName="photo"
            file={files.photo}
            preview={previews.photo}
            onFileChange={handleFileChange}
            onClear={() => clearFile('photo')}
            disabled={uploading}
          />
          
          <FileUploadWithPreview
            label="Swikrati Photo"
            fieldName="swikrati_photo"
            file={files.swikrati_photo}
            preview={previews.swikrati_photo}
            onFileChange={handleFileChange}
            onClear={() => clearFile('swikrati_photo')}
            disabled={uploading}
          />
          
          <FileUploadWithPreview
            label="Saman File"
            fieldName="saman_file"
            file={files.saman_file}
            preview={previews.saman_file}
            onFileChange={handleFileChange}
            onClear={() => clearFile('saman_file')}
            disabled={uploading}
            accept="image/*,application/pdf"
          />
        </div>

        <div className="flex gap-3 pt-4 border-t">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition font-medium"
            disabled={uploading}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 px-4 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition disabled:bg-indigo-400 disabled:cursor-not-allowed font-medium"
            disabled={uploading}
          >
            {uploading ? 'Updating...' : 'Update Patient'}
          </button>
        </div>
      </div>
    </div>
  );
}

// New FileUploadWithPreview component
function FileUploadWithPreview({ label, fieldName, file, preview, onFileChange, onClear, disabled, accept = "image/*" }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-3 h-40 flex flex-col">
        {preview ? (
          <div className="flex-1 flex flex-col">
            {preview === 'pdf' ? (
              <div className="flex-1 flex flex-col items-center justify-center bg-gray-100 rounded">
                <div className="text-red-500 mb-2">
                  <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-sm text-gray-600">PDF File</span>
              </div>
            ) : (
              <img 
                src={preview} 
                alt={`${label} preview`} 
                className="w-full h-24 object-cover rounded mb-2"
              />
            )}
            <div className="flex gap-2 mt-2">
              <input
                type="file"
                id={`file-${fieldName}`}
                onChange={(e) => onFileChange(e, fieldName)}
                className="hidden"
                accept={accept}
                disabled={disabled}
              />
              <label
                htmlFor={`file-${fieldName}`}
                className="flex-1 cursor-pointer text-center text-xs bg-blue-50 text-blue-600 hover:text-blue-700 px-2 py-1 rounded hover:bg-blue-100"
              >
                Change
              </label>
              <button
                onClick={onClear}
                className="flex-1 text-xs bg-red-50 text-red-600 hover:text-red-700 px-2 py-1 rounded hover:bg-red-100"
                disabled={disabled}
              >
                Clear
              </button>
            </div>
          </div>
        ) : (
          <>
            <input
              type="file"
              id={`file-${fieldName}`}
              onChange={(e) => onFileChange(e, fieldName)}
              className="hidden"
              accept={accept}
              disabled={disabled}
            />
            <div className="flex-1 flex flex-col items-center justify-center">
              <Upload className="h-8 w-8 text-gray-400 mb-2" />
              <label
                htmlFor={`file-${fieldName}`}
                className="cursor-pointer text-xs text-indigo-600 hover:text-indigo-700"
              >
                Upload {label}
              </label>
            </div>
          </>
        )}
        
      </div>
    </div>
  );
}

export default NorthstarDashboard;